import CompraForm from './CompraForm'
export {CompraForm}
export default CompraForm
